import React from "react";
import PropTypes from "prop-types";
import SellOutAreaDesktop from "./SellOutAreaDesktop";

function SellOutArea({ app, config }) {
  return <SellOutAreaDesktop app={app} config={config} />;
}

SellOutArea.defaultProps = {
  app: null,
  config: {},
};

SellOutArea.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default SellOutArea;
